import { GetAccessLink } from 'constants/staticLinks'
import { LanguageCode } from 'translations/Language'

export const getAccessLink = (language: string) => {
  switch (language) {
    case LanguageCode.FR:
      return GetAccessLink.FR
    case LanguageCode.DE:
      return GetAccessLink.DE
    case LanguageCode.ES:
      return GetAccessLink.ES
    case LanguageCode.NL:
      return GetAccessLink.NL
    case LanguageCode.EN:
      return GetAccessLink.EN
    default:
      return GetAccessLink.ALL_PURPOSE
  }
}
